import React, { useState } from "react";
import {toast} from 'react-hot-toast'
import { useSelector } from "react-redux";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

// import { saveUser } from "../../redux/user/UserAction";
import { useNavigate } from "react-router-dom";

const Kyc = ({newUserId}) => {
  // const dispatch = useDispatch()
  const navigate = useNavigate()
  const token = useSelector((state)=>state.user.token)
  const uid = useSelector((state)=>state.user.uid)
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [surname, setSurname] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [frontSideID, setFrontSideID] = useState(null);
  const [backSideID, setBackSideID] = useState(null);
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(null);
  const [frontSideIDPreview, setFrontSideIDPreview] = useState(null);
  const [backSideIDPreview, setBackSideIDPreview] = useState(null);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  const eastAfricanCountries = [
    { label: "Kenya" },
    { label: "Tanzania" },
    { label: "Uganda" },
    { label: "Rwanda" },
    { label: "Burundi" },
    { label: "South Sudan" },
    // Add more East African countries as needed
  ];

  // Define a mapping of country codes to country names
  const countryCodes = {
    Kenya: "+254",
    Tanzania: "+255",
    Uganda: "+256",
    Rwanda: "+250",
    Burundi: "+257",
    "South Sudan": "+211",
    // Add more country codes as needed
  };

  // Function to handle country selection
  const handleCountryChange = (event, newValue) => {
    setSelectedCountry(newValue);
    // Automatically set the country code for the selected country
    if (newValue && newValue.label in countryCodes) {
      setPhone(countryCodes[newValue.label]);
    } else {
      setPhone(""); // Clear the phone number if no country is selected
    }
  };

    // Function to handle file input change and display image preview
    const handleFileInputChange = (e, setImagePreview) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
            setImagePreview(event.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    };

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true)
    const data = new FormData();

    data.append("user[firstName]", firstName);
    data.append("user[middleName]", middleName);
    data.append("user[surname]", surname);
    data.append("user[phone]", phone);
    data.append("user[address]", address);
    data.append("user[profile_pic]", profilePhoto);
    data.append("user[id_front]", frontSideID);
    data.append("user[id_back]", backSideID);

    handleSubmitToApi(data)
  };

  function handleSubmitToApi(data) {
    fetch(`https://salama-api.onrender.com/users/${uid}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: data, // Make sure to stringify the data if it's an object
    })
      .then((response) => {
        if (response.ok) {
          // Check if the response status is 200
          return response.json();
        } else {
            // If the response status is not OK, parse the error response and throw it
            return response.json().then((errorData) => {
              throw new Error(errorData.message || "API request failed with an unknown error");
            });
        }
      })
      .then((responseData) => {
        console.log(responseData);
        // Reset form fields
        setFirstName("");
        setMiddleName("");
        setSurname("");
        setPhone("");
        setAddress("");
        setProfilePhoto(null);
        setFrontSideID(null);
        setBackSideID(null);
        setLoading(false)
        toast.success(`${responseData.message}`); 
        navigate('/user')
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        setLoading(false)
        toast.error(error.message);
        // Handle the error here, e.g., show an error message to the user.
      });
  }
  

  return (
    <Container maxWidth="lg" className="min-h-screen flex items-center">
      <div className="p-4 w-full h-full">
        <Typography
          variant="h4"
          align="center"
          className="mb-4 text-success"
          gutterBottom
        >
          KYC Information
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="First Name"
                variant="outlined"
                fullWidth
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Middle Name"
                variant="outlined"
                fullWidth
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Surname"
                variant="outlined"
                fullWidth
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={eastAfricanCountries}
                getOptionLabel={(option) => option.label}
                value={selectedCountry}
                onChange={handleCountryChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone"
                variant="outlined"
                fullWidth
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Address"
                variant="outlined"
                fullWidth
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Upload Documents
              </Typography>
            </Grid>
            {/* File input fields for profile photo, front side, and back side */}
            {/* ... (code for file input fields) */}
            <Grid item xs={12} sm={4}>
                <label htmlFor="profile-photo-input">
                    Upload Profile Photo:
                    <input
                    id="profile-photo-input"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                        setProfilePhoto(e.target.files[0]);
                        handleFileInputChange(e, setProfilePhotoPreview);
                    }}
                    />
                </label>
                {profilePhotoPreview && (
                    <img
                    src={profilePhotoPreview}
                    alt="Profile Preview"
                    style={{ maxWidth: "100%", maxHeight: "200px", marginTop: "10px" }}
                    />
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
            <label htmlFor="profile-photo-input">
                  Id Photo Front Side:
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                    setFrontSideID(e.target.files[0]);
                    handleFileInputChange(e, setFrontSideIDPreview);
                  }}/>
            </label>
                {frontSideIDPreview && (
                    <img
                    src={frontSideIDPreview}
                    alt="Front Side ID Preview"
                    style={{ maxWidth: "100%", maxHeight: "200px", marginTop: "10px" }}
                    />
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
            <label htmlFor="profile-photo-input">
              Id Photo Back Side:
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                    setBackSideID(e.target.files[0]);
                    handleFileInputChange(e, setBackSideIDPreview);
                  }} />
                  </label>
                {backSideIDPreview && (
                    <img
                    src={backSideIDPreview}
                    alt="Back Side ID Preview"
                    style={{ maxWidth: "100%", maxHeight: "200px", marginTop: "10px" }}
                    />
                )}
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                disabled={ loading }
              >
                {loading ? "loading ..." : "Submit KYC"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}

export default Kyc;
